import { requestApi } from './Api';

export const getLicenseTypes = (navigate, params) => {
  return requestApi({
    url: '/api/practitioner/license/list',
    method: 'POST',
    params,
    navigate
  });
};

export const getIssuersList = (navigate, params) => {
  return requestApi({
    url: '/api/practitioner/license/issuer/load',
    method: 'POST',
    params,
    navigate
  });
};
